<template>
	<div class="app">
		<div class="index_top">
			<div class="index_top_one">
				
				<div class="index_top_one_title">
					<div class="index_top_one_title_text1">
						环境科学与工程教研一体化平台
					</div>
					<div class="index_top_one_title_text2" style="text-wrap: nowrap;">
						Integrated Platform for Environmental Science and Engineering Teaching and Research	
					</div>

				</div>
				<div style="display: flex; flex-direction: row-reverse; width: 40%;">
					<div class="index_top_one_loginItems" v-if="haslogin">
						<div class="text">{{ studentName }}</div>
						<div class="text">｜</div>
						<div class="text" @click="loginOut()">退出登录</div>
					</div>
					<div class="index_top_one_loginItems" v-else @click="loginShow = true">
						<div class="text">登录</div>
						<div class="text">｜</div>
						<div class="text">注册</div>
					</div>
					<div class="index_top_one_search">
						<div class="index_top_one_search_save" @click="addToFavorites">
							收藏本站
						</div>
						<div style="display: flex;">
							<input class="index_top_one_search_input" placeholder="请输入搜索内容" />
							<div class="index_top_one_search_icon">
								<i class="el-icon-search" style="position: relative;top: 7px;"></i>
							</div>

						</div>

					</div>
			
				</div>

			</div>
			<div class="index_top_two">
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 1 || mouse1 == true ? 'index_top_two_item' : ''" @mouseover="mouse1 = true"
					@mouseleave="mouse1 = false" @click="changeIndex(1)">网站首页</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 2 || mouse2 == true ? 'index_top_two_item' : ''" @mouseover="mouse2 = true"
					@mouseleave="mouse2 = false" @click="changeIndex(2)">在线课程</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 3 || mouse3 == true ? 'index_top_two_item' : ''" @mouseover="mouse3 = true"
					@mouseleave="mouse3 = false" @click="changeIndex(3)">虚拟仿真</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 4 || mouse4 == true ? 'index_top_two_item' : ''" @mouseover="mouse4 = true"
					@mouseleave="mouse4 = false" @click="changeIndex(4)">师资力量</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 5 || mouse5 == true ? 'index_top_two_item' : ''" @mouseover="mouse5 = true"
					@mouseleave="mouse5 = false" @click="changeIndex(5)">科研与教学成果</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 6 || mouse6 == true ? 'index_top_two_item' : ''" @mouseover="mouse6 = true"
					@mouseleave="mouse6 = false" @click="changeIndex(6)">研究环境</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 7 || mouse7 == true ? 'index_top_two_item' : ''" @mouseover="mouse7 = true"
					@mouseleave="mouse7 = false" @click="changeIndex(7)">学生作品</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 8 || mouse8 == true ? 'index_top_two_item' : ''" @mouseover="mouse8 = true"
					@mouseleave="mouse8 = false" @click="changeIndex(8)">合作交流</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 9 || mouse9 == true ? 'index_top_two_item' : ''" @mouseover="mouse9 = true"
					@mouseleave="mouse9 = false" @click="changeIndex(9)">前沿文献预览</div>
				<div class="index_top_two_item_unactive"
					:class="activeIndex == 10 || mouse10 == true ? 'index_top_two_item' : ''" @mouseover="mouse10 = true"
					@mouseleave="mouse10 = false" @click="changeIndex(10)">学习资源库</div>

			</div>

		</div>

		<router-view>

		</router-view>
		<div class="index_footer">
			<div class="w1200">
				<div class="index_footer_link clearfix"><span>友情链接</span>
					<a target="_blank" href="https://www.icourse163.org/">中国慕课</a>
					<a target="_blank" href="http://www.moe.gov.cn/">中国教育部</a>
					<a target="_blank" href="https://www.jnu.edu.cn/">暨南大学官网</a>
					<!--<a target="_blank" class="index_footer_link_right" href="#">在线留言</a>-->
				</div>
				<div class="index_footer_list clearfix">
					<ul class="one">
						<li><a href="">在线课程</a></li>
						<li><a href="">师资力量(个人简介)</a></li>
						<li><a href="">科研与教学成果</a></li>
						<li><a href="">知识图谱</a></li>
					</ul>
					<!-- <div class="two">
						<ul>
							<li style="display: flex;">备案号：<img src="../images/info_35.jpg"
									style="width: 15px; height: 15px;margin-top: 4px;">
								<a href="https://beian.miit.gov.cn">粤ICP备2020135951号-1</a>
							</li>
							<li>中国大学精品开放课程适用于《中华人民共和国著作权法》</li>
							<li>高等教育出版社享有中国大学精品开放课程信息网络传播的专有使用权未经书面允许，请勿转播</li>
						</ul>
					</div> -->
					<!-- <ul class="three">
						<li><img src="../images/info_34.jpg">官方公众号</li>
						<li><img src="../images/info_34.jpg" />官方小程序</li>
					</ul> -->
				</div>
				<!-- <div class="index_footer_company">建设单位：暨南大学理工学院光电工程系<span>技术支持：广州唯华科技有限公司</span></div> -->
				<div class="index_footer_company" style="text-align: center;margin-top: 30px;">技术支持：广州唯华科技有限公司</div>
			</div>
		</div>
		<el-dialog title="登录" :visible.sync="loginShow" width="30%" center>
			<el-form label-width="80px" style="padding-left: 8%;">
				<el-form-item label="账号" prop="account" style="width: 300px;">
					<el-input v-model="account" placeholder="请输入账号" />
				</el-form-item>
				<el-form-item label="密码" prop="password" style="width: 300px;">
					<el-input v-model="password" placeholder="请输入密码" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="loginShow = false">取 消</el-button>
				<el-button type="primary" @click="toLogin()">登 录</el-button> -->
				<div style="display: flex; justify-content: center;">
					<div style="width: 130px;height: 31px;background: #1C8577;border-radius: 3px 3px 3px 3px; cursor: pointer; display: flex; align-items: center; justify-content: center;"
						@click="toLogin()">登 录</div>
				</div>

			</span>
		</el-dialog>
	</div>
</template>

<script>
import "@/assets/style.css"; //@代表的是你的项目根路径
import {
	isHasStudent
} from "../services/services";
export default {
	name: "Layout",
	data() {
		return {
			activeIndex: localStorage.getItem('activeIndex'),
			mouse1: false,
			mouse2: false,
			mouse3: false,
			mouse4: false,
			mouse5: false,
			mouse6: false,
			mouse7: false,
			mouse8: false,
			mouse9: false,
			mouse10: false,
			userId: localStorage.getItem('userId'),
			haslogin: false,
			loginShow: false,
			studentName: '',
			account: '',
			password: ''

		};
	},
	mounted() {
		localStorage.setItem('userId', 102);
		localStorage.setItem('activeIndex', 1);
		this.activeIndex = localStorage.getItem('activeIndex', 1);
	},
	created() {
		this.$router.push({
			path: '/',
		});
		localStorage.setItem('activeIndex', 1);
		if (localStorage.getItem('haslogin') == 1) {
			this.haslogin = true
			this.studentName = localStorage.getItem('studentName')
		}
	},
	methods: {
		loginOut() {
			localStorage.setItem('haslogin', 0);
			localStorage.removeItem('studentName');
			localStorage.removeItem('studentId');
			this.haslogin = false
			this.$message({
				message: '退出登录成功',
				type: 'success'
			});
		},
		toLogin() {
			isHasStudent(this.userId, this.account, this.password).then(res => {
				if (res.data.flag == 1) {
					localStorage.setItem('haslogin', 1);
					localStorage.setItem('studentName', res.data.studentName);
					localStorage.setItem('studentId', res.data.studentId);
					this.haslogin = true
					this.studentName = res.data.studentName
					this.loginShow = false
					this.$message({
						message: '登录成功',
						type: 'success'
					});
				}
				else {
					this.$message({
						message: '账号密码错误',
						type: 'warning'
					});


				}
				console.log(res)
			})



		},
		changeIndex(index) {
			localStorage.setItem('activeIndex', index);
			this.activeIndex = localStorage.getItem('activeIndex', index);
			if (index == 1) {
				this.$router.push({
					path: '/',
				});
			}
			else if (index == 2) {
				this.$router.push({
					path: '/zxkc',

				});
			}
			else if (index == 3) {
				this.$router.push({
					path: '/xnfz',

				});
			}
			else if (index == 4) {
				this.$router.push({
					path: '/szll',

				});
			}
			else if (index == 5) {
				this.$router.push({
					path: '/kycg',

				});
			}
			else if (index == 6) {
				this.$router.push({
					path: '/yjhj',

				});
			}
			else if (index == 7) {
				this.$router.push({
					path: '/xszp',

				});
			}
			else if (index == 8) {
				this.$router.push({
					path: '/hzjl',

				});
			}
			else if (index == 9) {
				this.$router.push({
					path: '/qywx',

				});
			}
			else if (index == 10) {
				this.$router.push({
					path: '/resourceLib',

				});
			}
			else {
				this.$router.push({
					path: '/',

				});
			}
		},
		addToFavorites() {
			const url = window.location.href;
			const title = document.title;

			try {
				if (window.external && ('addFavorite' in window.external)) {
					// IE
					window.external.addFavorite(url, title);
				} else if (window.sidebar && window.sidebar.addPanel) {
					// Firefox <= 22
					window.sidebar.addPanel(title, url, '');
				} else if (window.opera && window.print) {
					// Opera
					const a = document.createElement('a');
					a.setAttribute('href', url);
					a.setAttribute('title', title);
					a.setAttribute('rel', 'sidebar');
					a.click();
				} else {
					// 其他浏览器
					alert('请按 Ctrl+D (Windows) 或 Command+D (Mac) 键将此页加入收藏夹。');
				}
			} catch (e) {
				alert('您的浏览器不支持自动收藏，请使用快捷键进行手动收藏。');
			}

		},
	}
}
</script>

<style scoped>
.logo_img {
	float: left;
	width: 30%;
	cursor: pointer;
}

#back_to_top {
	position: fixed;
	bottom: 50px;
	right: 30px;
	cursor: pointer;
	z-index: 999999;
}

.header-title {
	font-size: 1em;
}

.company_name {
	font-weight: normal;
	font-size: 1em;
}

.footer_font {
	font-size: 1em;
}

#menu_index {
	float: left;
	width: 50%;
	height: 100%
}

.header {
	margin: auto;
	width: 100%;
	height: 61px;
	background: #2270b2;
	position: fixed;
	top: 0;
	z-index: 999;
}

@media screen and (max-device-width: 415px) {
	.logo_img {
		float: left;
		width: auto;
		cursor: pointer;
	}

	#back_to_top {
		position: fixed;
		bottom: 50px;
		right: 5px;
		cursor: pointer
	}

	.footer_font {
		font-size: 0.875em;
	}

	#menu_index {
		float: right;
		width: auto;
		height: 100%
	}

	.mobile_menu {}
}

#header-img {
	width: 150px;
	height: 50px;
	float: left;
	margin: auto;
}

.header-logo {
	height: 50px;
	width: 50px;
	align-self: center;
}

.header-important {
	float: left;
	margin-left: 6px;
	align-self: center;
}

.footer {
	display: flex;
	align-items: center;
	/* margin: 10px auto; */
	/* width: 90%; */
}

/**- footer -**/
.footer {
	width: 100%;
	/* background: url(../../static/slider/bg_footer_top.jpg); */
	background-size: 100% 100%;
	position: relative;
	/* z-index: 99999990; */
}

.footer .container {
	/* width: 51%; */
}

.footer .top {
	overflow: hidden;
	display: block;
	padding-top: 2.6%;
	margin-bottom: 0.6%;
}

.footer .top .left {
	float: left;
	width: 560px;
	padding: 1.62% 0;
	border-top: 1px #e79992 solid;
	border-bottom: 1px #e79992 solid;
}

.footer .top .left .left_text {
	width: 44.1%;
	float: left;
	line-height: 23px;
	font-size: 14px;
}

.footer .top .left .left_text .title {
	font-size: 20px;
	font-weight: bold;
	color: #fff;
	margin-bottom: 12%;
}

.footer .top .left .left_text p:hover {
	color: #fff;
	font-weight: bold;
}

.footer .top .left .left_text_margin {
	padding-left: 8%;
	border-left: 1px #e79992 solid;
	width: 47%;
}

.footer .top .footer_logo {
	display: block;
	float: right;
	padding-top: 6%;
	font-size: 2rem
}

.footer .center {
	padding-top: 1px;
	margin: 0 auto;
	padding-top: 3px;
	height: 96px;
	line-height: 40px;
	color: #fff;
	position: relative;
}

.footer .center .dt_ceng1 {
	position: absolute;
	bottom: 98px;
	width: 55%;
	left: 26px;
	z-index: 999;

	cursor: pointer;
}

/* .footer .center .dt_ceng .de-close {
	  position: absolute;
	  padding: 15px 15px 15px 15px;
	  top: 0px;
	  right: 0px;
	}
	.footer .center .dt_ceng .de-close img {
	  width: 28px;
	  height: 28px;
	} */
.footer .center .dt_ceng2 {
	position: absolute;
	bottom: 98px;
	width: 10%;
	left: 40%;
	z-index: 999;
	/*  display: none; */
	cursor: pointer;
}

.footer .center .dt_ceng3 {
	position: absolute;
	bottom: 98px;
	width: 10%;
	left: 45%;
	z-index: 999;
	/*  display: none; */
	cursor: pointer;
}

.footer .center .dt_ceng2 .de-close {
	position: absolute;
	padding: 15px 15px 15px 15px;
	top: 0px;
	right: 0px;
}

.footer .center .dt_ceng2 .de-close img {
	width: 28px;
	height: 28px;
}

.footer .center .wx_ewm_ceng {
	position: absolute;
	top: -145px;
	width: 135px;
	left: 390px;
	display: none;
}

.footer .center .wb_ewm_ceng {
	position: absolute;
	top: -145px;
	width: 135px;
	left: 390px;
	display: none;
}

.footer .center span {
	display: inline-block;
	font-size: 14px;
	float: left;
}

.footer .center .dz_biao {
	padding-top: 20px;
	margin-top: -16px;
	height: 39px;
	padding-right: 15px;
}

.footer .center .dz_biao img {
	animation: dtbiao 1s linear 0s infinite;
	-webkit-animation: dtbiao 1s linear 0s infinite;
	-moz-animation: dtbiao 1s linear 0s infinite;
	-o-animation: dtbiao 1s linear 0s infinite;
}

.footer .center .ewm {
	float: left;
	width: 4.16%;
	height: 36px;
}

.footer .center .ewm1 {
	padding: 0px 15px 0px 25px;
}

.footer .bottom {
	width: 100%;
	background-color: #232323;
}

.footer .bottom div {
	font-size: 14px;
	margin: 0 auto;
	overflow: hidden;
	height: 48px;
	line-height: 48px;
	color: #fff;
}

.footer .bottom div p {
	display: block;
	height: 48px;
	line-height: 48px;
}

.footer .bottom div p a:hover {
	color: #2270b2;
}

.el-menu {
	background-color: #2270b2;
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
	background-color: rgb(255, 57, 57);
}

.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
	background-color: rgb(255, 57, 57) !important;
}


.el-menu--horizontal>.el-menu-item.is-active {
	color: #FFF !important;
}

a {
	text-decoration: none;
}

a:visited {
	text-decoration: none;
}

a:hover {
	text-decoration: none;
}

a:active {
	text-decoration: none;
}
</style>
<style>
/* 或者本地文件 */
@import url('../css/style.css');
</style>